export const extractValidJson = (input) => {
    const jsonRegex = /{[^]*}/g;
    const matches = input.match(jsonRegex);
    if (matches) {
        for (const match of matches) {
            try {
                return JSON.parse(match);
            }
            catch (error) {
                // Continue to the next match if parsing fails
            }
        }
    }
    return null;
};
